import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { GUIDES, GUIDES_INDEX } from '../data/guides';
import { guidesIndexJsonLd } from '../data/pageSchema';
import './AreaPage.css';

const GuidesIndexPage = () => (
  <div className="area-page">
    <Seo
      title={GUIDES_INDEX.title}
      description={GUIDES_INDEX.description}
      path={GUIDES_INDEX.path}
      jsonLd={guidesIndexJsonLd(GUIDES_INDEX, GUIDES)}
    />
    <header className="area-hero">
      <div className="hero-bg-lines" aria-hidden="true" />
      <div className="area-hero-content">
        <div className="hero-eyebrow">South Wales</div>
        <h1>{GUIDES_INDEX.h1}</h1>
        {GUIDES_INDEX.intro.map((paragraph) => (
          <p key={paragraph} className="area-lead">{paragraph}</p>
        ))}
      </div>
    </header>
    <div className="page-wrapper">
      <section className="area-block" aria-labelledby="guide-list-heading">
        <h2 id="guide-list-heading">Read a <span>guide</span></h2>
        <div className="area-index-grid">
          {GUIDES.map((guide) => (
            <Link key={guide.slug} to={guide.path} className="area-index-card">
              <h3>{guide.h1}</h3>
              <p>{guide.description}</p>
            </Link>
          ))}
        </div>
      </section>
      <section className="area-card area-block">
        <h2>Why post on <span>The WasteGame</span></h2>
        <ol className="area-list">
          {GUIDES_INDEX.reasons.map((reason) => (
            <li key={reason}>{reason}</li>
          ))}
        </ol>
      </section>
      <section className="area-cta">
        <h2>Post a job <span>free</span></h2>
        <p>Posting does not book a van, and it does not mean anyone will send a price.</p>
        <div className="area-cta-actions">
          <Link to="/signup" className="btn btn-primary">Post a job free</Link>
          <Link to="/areas" className="btn btn-secondary">All areas</Link>
        </div>
      </section>
    </div>
  </div>
);

export default GuidesIndexPage;
